(function () {
    'use strict';

    angular.module('swif.openbase')

    .config(function($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/site_categories/table_view', {
            templateUrl: 'partials/openbase/site_categories_table_view.html',
            controller: 'SwifSiteCategoriesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    })

    .factory('swifOpenbaseSiteCategoryService',
        function (swif) {
            'ngInject';
            var service = {};
            service.createCollection = function () {
                var filter = {};
                swif.data.sortOn(filter, 'name', 'ASC');
                return swif.collections.createOrUpdate('site_categories', 'site_category', filter);
            };
            service.getCollection = function () {
                return swif.collections.getCollection('site_categories');
            };
            service.callback = function (error, data) {
                var collection = service.getCollection();
                collection.defaultActionCallback(error, data);
                if (!error) {
                    if (data.action.id === 'delete-unused') {
                        collection.getItems();
                    }
                }
            };
            service.preModal = function (data) {
                service.getCollection().preModal(data);
                if (data.action.id === 'delete-unused') {
                    var filter = {};
                    filter.fields = ['type_id'];
                    swif.data.setLimit(filter, 0);

                    swif.data.groupRead('site', filter, 'type_id').then(function (siteByType) {
                        var type_ids_used = [];
                        var ofilter = {};
                        _.forEach(siteByType, function(type) {
                            type_ids_used.push(type.type_id[0]);
                        });
                        swif.data.addFilter(ofilter, 'id', 'not in', type_ids_used);
                        swif.data.searchRead('site_category', ofilter).then(function (categories) {
                            swif.data.replaceObj(data.model, {ids: categories.ids});
                        });
                    });
                }

            };
            service.preValidate = function (data) {
                return service.getCollection().preValidate(data);
            };
            return service;
        }
    )

    .controller('SwifSiteCategoriesController',
        function ($scope, swifOpenbaseSiteCategoryService) {
            'ngInject';
            swifOpenbaseSiteCategoryService.createCollection().then(function (collection) {
                $scope.site_categories = collection;
            });
            $scope.preModal = swifOpenbaseSiteCategoryService.preModal;
            $scope.preValidate = swifOpenbaseSiteCategoryService.preValidate;
            $scope.callback = swifOpenbaseSiteCategoryService.callback;
        }
    )

    .controller('OpenbaseSiteCategorieController',
        function ($scope, swif) {
            'ngInject';
            console.log('init OpenbaseSiteCategorieController');
            $scope.modules = swif.module.modules;
        }
    );

})();
